import { all } from "redux-saga/effects";
// Import sagas as they are created
import startupSaga from "./startupSaga";
import libraryCardSaga from "./libraryCardSaga";
import videoSubmissionSaga from "./videoSubmissionSaga";
import videoRenderSaga from "./videoRenderSaga";
import publicationScheduleSaga from "./publicationScheduleSaga";
import contentFeedSaga from "./contentFeedSaga";
import advertisingAgentSaga from "./advertisingAgentSaga";
import documentSubmissionSaga from "./documentSubmissionSaga";
import reporterAgentSaga from "./reporterAgentSaga";
import contentBacklogSaga from "./contentBacklogSaga";
import researchDeckSaga from "./researchDeckSaga";
import playwrightRegressionSaga from "./playwrightRegressionSaga";
import diagramsAgentSaga from "./diagramsAgentSaga";
// import mediaSaga from "./mediaSaga";

export default function* rootSaga() {
  yield all([
    startupSaga(),
    libraryCardSaga(),
    videoSubmissionSaga(),
    videoRenderSaga(),
    publicationScheduleSaga(),
    contentFeedSaga(),
    advertisingAgentSaga(),
    documentSubmissionSaga(),
    reporterAgentSaga(),
    contentBacklogSaga(),
    researchDeckSaga(),
    playwrightRegressionSaga(),
    diagramsAgentSaga(),
    // mediaSaga(),
    // Add more sagas as needed
  ]);
}
